module.exports = __webpack_public_path__ + "static/img/tab5.f0c139f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab5.png
// module id = LzCF
// module chunks = 0